import { ThemeBorderRadiiKeys } from '@agria/theme/src/styles/tokens/borderRadii';
import { ThemeColorsKeys } from '@agria/theme/src/styles/tokens/colors';
import { ThemeSpaceKeys } from '@agria/theme/src/styles/tokens/space';
import { colors } from '@agria/theme/src/styles/tokens';
import { inputTokens } from '@agria/theme/src/const/tokens';

export type FormBaseTokens = {
  tickFill: string;
  tickWidth: string;
  tickHeight: string;
  checkedBackground: ThemeColorsKeys;
  checkedBorderColor: ThemeColorsKeys;
  borderRadius: ThemeBorderRadiiKeys;
  borderSize: string;
  size: 'small' | 'medium' | 'large';
  focusBoxShadow: string;
  focusValidBoxShadow: string;
  focusInvalidBoxShadow: string;
  formFieldPaddingLarge: ThemeSpaceKeys;
  formFieldBorderColor: ThemeColorsKeys;
  hoverBorderColour: ThemeColorsKeys;
  placeHolderColor: ThemeColorsKeys;
  labelBeforeTop: string;
  labelAfterTop: string;
  labelTopMargin: string;
  borderCorrection: boolean;
  transition: string;
  tickLeft: string;
  checkboxBorderColor: ThemeColorsKeys;
};

const tokens: FormBaseTokens = {
  tickFill: `data:image/svg+xml,%3Csvg width='16' height='12' viewBox='0 0 16 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.35481 11.6191C5.05269 11.6191 4.76255 11.4988 4.54879 11.2851L0.833895 7.5702C0.388701 7.125 0.388701 6.40334 0.833895 5.95815C1.27909 5.51295 2.00075 5.51295 2.44594 5.95815L5.35481 8.86702L13.888 0.833893C14.3331 0.388699 15.0548 0.388699 15.5 0.833893C15.9452 1.27909 15.9452 2.00075 15.5 2.44594L6.16083 11.2851C5.94707 11.4988 5.65692 11.6191 5.35481 11.6191Z' fill='white'/%3E%3C/svg%3E%0A`,
  tickWidth: '15.33px',
  tickHeight: '11.12px',
  tickLeft: '4px',
  checkedBackground: 'brandTwo100',
  checkedBorderColor: inputTokens.borderValid as ThemeColorsKeys,
  borderRadius: 'medium',
  borderSize: '1px',
  size: 'medium',
  focusBoxShadow: `${colors.systemFocus};`,
  focusValidBoxShadow: `${colors.systemFocusValid};`,
  focusInvalidBoxShadow: `${colors.systemFocusInvalid};`,
  formFieldPaddingLarge: 'small',
  formFieldBorderColor: 'brandOne120',
  hoverBorderColour: 'brandTwo100',
  checkboxBorderColor: colors[
    inputTokens.borderDefault as ThemeColorsKeys
  ] as ThemeColorsKeys,
  placeHolderColor: 'brandOne100',
  labelBeforeTop: '0',
  labelAfterTop: '6px',
  labelTopMargin: '0',
  borderCorrection: false,
  transition: 'all 0.2s ease',
} as const;

export default tokens;
